// path: luul/client/src/redux/actions/socialActions.js
import * as types from './actionTypes';

// Use this for initial fetch AND after adding a friend (refetch)
export const setFriendsList = (friends) => ({
  type: types.SET_FRIENDS_LIST,
  payload: friends,
});

// Use this for the Socket.io real-time status pings
export const updateFriendStatus = (friendId, status) => ({
  type: types.UPDATE_FRIEND_STATUS,
  payload: { friendId, status },
});
